<template>
  <div>
    <div class="pc-block__title">
      {{ $t('pc.password.title') }}
    </div>
    <validation-observer v-slot="{valid}">
      <validation-provider
        v-slot="{failedRules, dirty, invalid}"
        ref="password1"
        :bails="false"
        rules="required|password|pw_length:8,20|pw_alpha|pw_numeric|pw_symbols"
      >
        <pc-text-input
          v-model="password1"
          :errors="[failedRules.password,...backendErrors.password1].filter(el => !!el)"
          :label="$t('pc.password.enter-password')"
          required
          type="password"
          :mask-options="{mask:/^\S+(?:\s\S+)*$/}"
          :force-hint="invalid && dirty"
        >
          <template #hint>
            <password-hint :failed-rules="failedRules" :dirty="dirty" />
          </template>
        </pc-text-input>
      </validation-provider>
      <validation-provider v-slot="{errors}" :rules="{pw_confirm: password1}">
        <pc-text-input
          v-model="password2"
          :errors="errors"
          :label="$t('pc.password.confirm-password')"
          required
          type="password"
        />
      </validation-provider>
      <pc-button
        class="password-update-btn"
        :disabled="!valid"
        variant="main"
        @click="changePassword"
      >
        {{ $t('pc.password.change-password') }}
      </pc-button>
    </validation-observer>
    <pc-modal-wrapper v-if="showPasswordChangeSuccess">
      <pc-modal-container :show-close="false">
        <div class="pc-modal__content">

          <icu-icon class="pc-success pc-modal__image"></icu-icon>
          <h3>{{ $t('change-password.successful-change') }}</h3>
          <div class="pc-modal__actions">
            <pc-button :disabled="false" @click.native="showPasswordChangeSuccess = false">
              {{ $t('change-password.go-back-to-cabinet') }}
            </pc-button>
          </div>
        </div>
      </pc-modal-container>
    </pc-modal-wrapper>
  </div>
</template>

<script>
import PcTextInput from '@/components/inputs/PcTextInput'
import FormGroup from '@/components/views/RegisterPage/FormGroup'
import PcButton from '@/components/common/PcButton'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {api} from '@/api/api'
import {mapGetters} from 'vuex'
import {v4 as uuidv4} from 'uuid'
import PcModalWrapper from '@/components/modals/PcModalWrapper'
import PcModalContainer from '@/components/modals/PcModalContainer'
import IcuIcon from '@/components/common/IcuIcon'
import PasswordHint from '@/components/misc/PasswordHint.vue'

export default {
  name: 'PcPasswordChange',
  components: {
    PasswordHint,
    IcuIcon,
    PcModalContainer,
    PcModalWrapper, PcButton, FormGroup, PcTextInput, ValidationObserver, ValidationProvider},
  data(){
    return {
      password1: '',
      password2: '',
      backendErrors: {},
      verifyId: null,
      showPasswordChangeSuccess: false
    }
  },
  computed: {
    ...mapGetters(['otpConfirmed'])
  },
  watch:{
    otpConfirmed(newVal){
      if(newVal === this.verifyId) {
        this.showPasswordChangeSuccess = true
        this.password1 = ''
        this.password2 = ''
        this.$refs.password1.reset()

      }
    }
  },
  methods: {
    changePassword() {
      const id = uuidv4()
      this.verifyId = id
      this.$store.dispatch('showOtp', {
        id,
        getCodeApi: api.auth.changePassword,
        getCodeApiData: {password1: this.password1, password2: this.password2},
        confirmCodeApi: api.auth.changePasswordConfirm,
        showContacts: false,
        hideCountdown: false
      })

    }
  }
}
</script>

<style scoped>
.password-update-btn {
  margin-top: 30px;
}
</style>
